import { ReactElement } from 'react'
import { H5 } from 'syf-component-library/ui/typography'
import i18n from 'strings/i18n'
import redirectToUrl from 'helpers/redirectToUrl'
import config from 'const/config'
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth'
import {
  Image,
  ImageWrapper,
  MarketPlaceButton,
  MarketPlaceContainer,
  MarketPlaceContent,
  MarketPlaceDescription,
  MarketPlaceGrid,
  MarketPlaceTextContainer
} from './subcomponents'

const MarketPlace = (): ReactElement => {
  const windowWidth = useWindowSize()
  const handleExploreOffers = () => {
    const clientName = localStorage.getItem('client')
    redirectToUrl(
      `https://www.synchrony.com/marketplace?intcmp=vista_${clientName}_logout_Sessionlogout_synchrony_int`
    )
  }

  const imageUrl = `${config.ASSETS_HOST}/assets/vista/${
    windowWidth.isLessThanMobile
      ? 'market_place_mobile.svg'
      : 'market_place_desktop.svg'
  }`

  return (
    <MarketPlaceContainer>
      <MarketPlaceGrid>
        <ImageWrapper>
          <Image
            alt="Market Place"
            data-cy="market-place-image"
            data-test="marketplaceimage"
            height="100"
            src={imageUrl}
            width="100%"
          />
        </ImageWrapper>
        <MarketPlaceContent>
          <MarketPlaceTextContainer>
            <H5 data-cy="market-place-title" weight="bold">
              {i18n({ marketPlace: 'title' })}
            </H5>

            <MarketPlaceDescription data-cy="market-place-description">
              {i18n({ marketPlace: 'description' })}
            </MarketPlaceDescription>
          </MarketPlaceTextContainer>
          <MarketPlaceButton
            buttonType="primary"
            onClick={handleExploreOffers}
            dataCy="explore-offers"
            data-type="Session logout"
            data-reason="explore offers"
            data-object="button"
            data-test="exploreOffer"
            data-analytics="clicktrackingevent"
          >
            {i18n({ button: 'exploreOffers' })}
          </MarketPlaceButton>
        </MarketPlaceContent>
      </MarketPlaceGrid>
    </MarketPlaceContainer>
  )
}
export default MarketPlace
